import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IRuleGroup } from "./RuleGroup";

export interface TEvaluationType {
  id: number;
  name: string;
  description: string;
}

export interface IEvaluationType extends TEvaluationType {
  groups: IRuleGroup[];
}

const EvaluationType = Model(
  (model: TEvaluationType): IEvaluationType => {
    const _evaluationType: TEvaluationType = Object.assign({}, model);
    let _groups: IRuleGroup[] = [];
    let create = (evaluationType: IEvaluationType): IEvaluationType => {
      let obj = ValidatableObject(evaluationType);
      return obj;
    };

    let evaluationType = {
      get id() {
        return _evaluationType.id;
      },
      set id(value) {
        _evaluationType.id = value;
      },
      get name() {
        return _evaluationType.name;
      },
      set name(value) {
        _evaluationType.name = value;
      },
      get description() {
        return _evaluationType.description;
      },
      set description(value) {
        _evaluationType.description = value;
      },
      get groups() {
        return _groups;
      },
      set groups(value) {
        _groups = value;
      }
    };

    return create(evaluationType);
  }
);

export default EvaluationType;
